import { render, staticRenderFns } from "./CreateData.vue?vue&type=template&id=bd586f70&"
import script from "./CreateData.vue?vue&type=script&lang=js&"
export * from "./CreateData.vue?vue&type=script&lang=js&"
import style0 from "./CreateData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports